import React, { Component } from 'react'
import '../App.css'
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid'
//import IconButton from '@material-ui/core/IconButton'
//import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import * as d3 from 'd3';
import { TimeSeries } from "pondjs";
import { Charts, ChartContainer, ChartRow, YAxis, AreaChart, Legend, Resizable, styler } from "react-timeseries-charts";

import ReactTooltip from "react-tooltip"

import PlotIndicator from '../components/PlotIndicator';

const styles = theme => ({
  progress: {
    margin: theme.spacing(2),
  },
  container: {
    //marginTop: '40px',
    backgroundColor: '#f3f3f3',
    width: '100%',
    height: '450px',
    [theme.breakpoints.down('xs')]: {
      //width: '300px',
      height: '350px',
    },
    [theme.breakpoints.up('sm')]: {
      //width: '400px',
      height: '400px',
    },
    [theme.breakpoints.up('md')]: {
      //width: '400px',
      height: '450px',
    },
    [theme.breakpoints.up('lg')]: {
      //width: '400px',
      height: '430px',
    },
    //[theme.breakpoints.up('xl')]: {
    //width: '600px',
    //},
    fontFamily: 'Nunito Sans Regular!important',
  },
  relativeContainer: {
    position: 'relative',
    width: '100%',
  },
  absoluteContainer: {
    position: 'absolute',
    top: '60px',
    right: '5px',
  },
  topLegend: {
    width: '90%',
    fontFamily: 'Nunito Sans Bold!important',
    fontSize: '16pt',
    padding: "10px",
    paddingLeft: '5%',
    textAlign: 'left',
    
  },
  chartDiv: {
    width: '90%',
    margin: '0 auto',
    paddingTop:'2px',
    paddingBottom:'2px',
    //paddingLeft:'5%',
    //backgroundColor: '#ff0000',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  chart: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '300px',
      height: '300px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '400px',
      height: '350px',
    },
    [theme.breakpoints.up('md')]: {
      width: '350px',
      height: '350px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '400px',
      height: '320px',
    },
    [theme.breakpoints.up('xl')]: {
      width: '500px',
    },
    margin: 'auto',
  },
  indicatorTooltipContainer: {
    color: 'black',
    width: '100%',
  },
  toolTipIconButton: {
    width: '24px',
    height: '24px',
    //alignSelf: 'flex-end!important',
    alignSelf: 'center!important',
  },
  toolTip: {
    textAlign: 'left',
    color: 'fff!important',
    backgroundColor: '#333333',
    fontFamily: 'Nunito Sans Regular!important',
    fontWeight:700,
    minHeight: '50px',
    opacity:'1!important',
  },
  bottomLegend: {
    fontFamily: 'Nunito Sans Regular!important',
  },
  timeplotLegend: {
    justifyContent: 'center',
  },
  legendBox: {
    borderRadius: '5px',
    border: '1px solid #8b7f7e',
    padding: '5px',
    display: 'inline-block',
    fontFamily: 'Nunito Sans Regular!important',
    fontSize: '12pt',
    backgroundColor: '#069999',
    color: 'white',
    width: '75px',
    minWidth: '75px',
    maxWidth: '75px',
  },
});

class TimePlot extends Component {
  state = {
    dataReady: false,
    componentUpdated: false,
    data: {
      solar: [],
      wind: [],
      windOffshore: [],
    },
    plotData: {},
    currentTech: {
      solar: true,
      wind: false,
      windOffshore: false,
    },
    currentMode: 'realtime',
    currentFilter: 'energy',
    currentDateTime: new Date().getTime(),

    //xScale: d3.scaleLinear().clamp(true),
    yScale: d3.scaleLinear().clamp(true),
    //format: d3.format('~s'),

    size: [400, 200],
    plotConfig: {
      unit: "Wh",
      color: {
        solar: '#fce0d4',
        wind: '#1eb0e6',
        windOffshore: '#1eb0e6',
      },
    },
    timeSeriesChart: {
      highlight: null,
      selection: null,
      scheme: "Paired",
      series: [],
      columnNames: [],
      seriesUpdated: true,
    },

    tracker: null,
    trackerValue: 0,
    trackerEvent: null,

    hasForecast: false,
    hasMixedForecast: false,

    yAxisWidth: 60,

    lang:'fr',
  }

  componentDidUpdate() {
    if (this.props.dataReady) {
      if (!this.state.componentUpdated)
        this.updatePlotData()
      else {
        let stateupdated = (
          //this.props.currentTech === this.state.currentTech
          JSON.stringify(this.props.currentTech) === JSON.stringify(this.state.currentTech)
          && this.props.currentMode === this.state.currentMode
          && this.props.currentFilter === this.state.currentFilter
          && this.props.currentDateTime === this.state.currentDateTime
          && this.props.data === this.state.data
          && this.props.lang === this.state.lang
        )
        if (!stateupdated) {
          this.setState({ componentUpdated: false })
        }
      }
    }
    else {
      if (this.state.componentUpdated) {
        this.setState({ componentUpdated: false })
      }
    }
  }

  updatePlotData() {
    //const max = d3.max(this.props.data[0].values, function (t) {
    //  return t.value
    //});
    const name = 'Production'

    const actualDate = new Date();
    const currentSelectedDate = new Date(this.props.currentDateTime)
    const hasForecast = (currentSelectedDate.toDateString() === actualDate.toDateString() || currentSelectedDate.getTime() > actualDate.getTime())

    let hasMixedForecast = false
    if (hasForecast) {
      if (currentSelectedDate.toDateString() === actualDate.toDateString())
        hasMixedForecast = true
    }
    let plotData = []
    let transitionPending = false

    if (hasForecast) {
      if (hasMixedForecast) {
        this.props.data.map(d => {
          transitionPending = false
          let originalValues = d.values.map(obj => {
            if (!transitionPending) {
              if (new Date(obj.datetime).getTime() > actualDate.getTime()) {
                transitionPending = true
              }
              return { datetime: obj.datetime, value: obj.value }
            }
            else
              return { datetime: obj.datetime, value: null }
          })
          let originalDataSeries = {
            name: (d.name),
            values: originalValues
          }
          plotData.push(originalDataSeries)
          let forecastValues = d.values.map(obj => {
            if (new Date(obj.datetime).getTime() >= actualDate.getTime()) {
              return { datetime: obj.datetime, value: obj.value }
            }
            else {
              return { datetime: obj.datetime, value: null }
            }
          })
          let forecastDataSeries = {
            name: (d.name + "Forecast"),
            values: forecastValues
          }
          plotData.push(forecastDataSeries)
          return true
        })
      }
      else {
        plotData = this.props.data.map(d => {
          return {
            name: (d.name + "Forecast"),
            values: d.values
          }
        })
      }
    }
    else {
      plotData = this.props.data
    }

    let columnNames = plotData.map(d => d.name);
    const columns = ["time", ...columnNames];

    let points = []
    for (let i = 0; i < plotData[0].values.length; i++) {
      const t = plotData[0].values[i].datetime
      const point = [t];
      plotData.map(d => {
        point.push(d.values[i].value);
        return true
      });
      points.push(point);
    }
    const currentDateTime = this.props.currentDateTime
    const series = new TimeSeries({ name, columns, points })
    const timeInSeries = plotData[0].values
      .filter(obj => obj.datetime.getTime() === currentDateTime.getTime())

    const trackerEvent = series.atTime(timeInSeries[0].datetime)

    this.setState((previousState, props) => {
      return {
        dataReady: true,
        componentUpdated: true,
        currentDateTime: this.props.currentDateTime,
        currentTech: this.props.currentTech,
        currentMode: this.props.currentMode,
        currentFilter: this.props.currentFilter,

        data: this.props.data,
        plotData: plotData,
        timeSeriesChart:
        {
          ...previousState.timeSeriesChart,
          series: series,
          columnNames: columnNames,
          seriesUpdated: true,
        },
        tracker: this.props.currentDateTime,
        trackerValue: this.props.trackerValue,
        trackerEvent: trackerEvent,
        hasForecast: hasForecast,
        hasMixedForecast: hasMixedForecast,

        lang:this.props.lang,
      };
    });
  }

  render() {
    const { classes } = this.props;

    if (!this.props.dataReady || !this.state.dataReady || !this.state.componentUpdated) {
      return (
        <div className={classes.chartDiv}>
          <CircularProgress className={classes.progress} size={50} />
        </div>
      )
    }
    const solarColorArray = ['#fff292', '#ffeb81', '#ffe471', '#ffdc5e', '#ffd349', '#ffcc33', '#fbbb3b', '#f7aa41', '#f29945', '#ed8749', '#e8754c']
    const windColorArray = ['#bfd6e2', '#abc8d7', '#98bacc', '#87acc0', '#779eb3', '#6890a5', '#5a8197', '#4e7488', '#43667a', '#39596a', '#304c5b']
    const windOffshoreColorArray = ['#b8dadd', '#afdadd', '#a4dadd', '#9ed9dd', '#92d9dd', '#86d9dd', '#7ad8de', '#6ed8de', '#5cd8de', '#41d8df', '#06d8e0']

    let locale
    switch (this.props.lang) {
      case "de":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
          "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          "months": ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
          "shortMonths": ["", "Jan", "", "Mar", "", "Mai", "", "Jul", "", "Sep", "", "Nov", ""]
        })
        break
      case "en":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "shortDays": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          "months": ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          "shortMonths": ["", "Jan", "", "Mar", "", "May", "", "Jul", "", "Sep", "", "Nov", ""]
        })
        break
      case "fr":
      default:
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
          "shortDays": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
          "months": ["", "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "aôut", "septembre", "octobre", "novembre", "décembre"],
          "shortMonths": ["", "jan", "", "mar", "", "mai", "", "jui", "", "sep", "", "nov", ""]
        })
    }



    const cols = { up: this.state.timeSeriesChart.columnNames, down: [] };
    let maxSeries = 0
    if (this.state.dataReady) {
      for (let i = 0; i < this.state.plotData.length; i++) {
        let maxPlotData = d3.max(this.state.plotData[i].values, function (t) {
          //return d3.max(Object.values(t.value))
          return t.value
        });
        if (maxPlotData > maxSeries)
          maxSeries = maxPlotData
      }
    }
    let max = 1
    let yLabelOffset = -5
    let yAxisFormat = "d";
    if (maxSeries > 1) {
      max = Math.pow(10, Math.ceil(Math.log10(maxSeries)));
      while (maxSeries < max / 2)
        max = max / 2
      if (max < 5) {
        //yAxisFormat=",.2f"
        //yAxisFormat = d3.format(",.2f")
        yAxisFormat = (number) => { return number.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
      }
      else {
        if (max < 10)
          //yAxisFormat = d3.format(",.1f")
          yAxisFormat = (number) => { return number.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
      }
    }
    else {
      max = Math.pow(10, Math.floor(Math.log10(maxSeries)));
      //yAxisFormat = d3.format(",.2f")
      yAxisFormat = (number) => { return number.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
      //yLabelOffset=25
      do {
        max = max * 2
      }
      while (maxSeries > max)
      if (max < 0.5)
        //yAxisFormat = d3.format(",.3f")
        yAxisFormat = (number) => { return number.toLocaleString('nl-BE', { minimumFractionDigits: 3, maximumFractionDigits: 3 }) }
    }

    const interpolationType = "curveCatmullRom";
    //enum ("curveBasis", "curveBasisOpen", "curveBundle", 
    //"curveCardinal", "curveCardinalOpen", "curveCatmullRom", 
    //"curveCatmullRomOpen", "curveLinear", "curveMonotoneX", 
    //"curveMonotoneY", "curveNatural", "curveRadial", 
    //"curveStep", "curveStepAfter", "curveStepBefore")

    const legendLabelStyle = {
      fontSize: "normal",
      color: "#ffffff!important",
      solar: { fontSize: "normal", color: "#ffffff" },
      wind: { fontSize: "normal", color: "#ffffff" },
      windOffshore: { fontSize: "normal", color: "#ffffff" },
      normal: { fontSize: "normal", color: "#ffffff" },
      highlighted: { fontSize: "1.2em", color: "#ffffff" },
      selected: { fontSize: "1.2em", color: "#ffffff" },
      muted: { fontSize: "1.2em", color: "#ffffff" },
    }

    const legendStyle = styler([
      {
        key: "solar",
        color: solarColorArray[5],
        labelStyle: { color: '#ffffff', backgroundColor:'#333333' },
        paddingLeft: '20px',
      },
      {
        key: "wind",
        color: windColorArray[5],
        labelStyle: { fontSize: "normal", color: "#ffffff" },
      },
      {
        key: "windOffshore",
        color: windOffshoreColorArray[5],
        labelStyle: { fontSize: "normal", color: "#ffffff" },
      },
      {
        key: "solarForecast",
        color: solarColorArray[0],
        labelStyle: {
          normal: { fontSize: "normal", color: "#ffffff" },
          highlighted: { fontSize: "1.2em", color: "#ffffff" }
        },
      },
      {
        key: "windForecast",
        color: windColorArray[0],
        labelStyle: legendLabelStyle,
      },
      {
        key: "windOffshoreForecast",
        color: windOffshoreColorArray[0],
        labelStyle: legendLabelStyle,
      },
    ]);


    const plotStyle = {
      solar: {
        line: {
          normal: { stroke: "#e0b29b", fill: "none", strokeWidth: 2 },
          highlighted: { stroke: "#c3714b", fill: "none", strokeWidth: 3 },
        },
        area: {
          //normal: { fill: this.props.colorArray[5], stroke: "none", opacity: 0.5 },
          //highlighted: { fill: this.props.colorArray[6], stroke: "none", opacity: 0.8 },
          normal: { fill: solarColorArray[5], stroke: "none", opacity: 0.5 },
          highlighted: { fill: solarColorArray[6], stroke: "none", opacity: 0.8 },
        }
      },
      wind: {
        line: {
          normal: { stroke: "#9dbfcb", fill: "none", strokeWidth: 2 },
          highlighted: { stroke: "#2f6273", fill: "none", strokeWidth: 3 },
        },
        area: {
          //normal: { fill: this.props.colorArray[5], stroke: "none", opacity: 0.5 },
          //highlighted: { fill: this.props.colorArray[6], stroke: "none", opacity: 0.8 },
          normal: { fill: windColorArray[5], stroke: "none", opacity: 0.5 },
          highlighted: { fill: windColorArray[6], stroke: "none", opacity: 0.8 },
        }
      },
      windOffshore: {
        line: {
          normal: { stroke: "#aadadd", fill: "none", strokeWidth: 2 },
          highlighted: { stroke: "#880000", fill: "none", strokeWidth: 3 },
        },
        area: {
          //normal: { fill: this.props.colorArray[5], stroke: "none", opacity: 0.5 },
          //highlighted: { fill: this.props.colorArray[6], stroke: "none", opacity: 0.8 },
          normal: { fill: windOffshoreColorArray[5], stroke: "none", opacity: 0.5 },
          highlighted: { fill: windOffshoreColorArray[6], stroke: "none", opacity: 0.8 },
        }
      },
      solarForecast: {
        line: {
          normal: { stroke: "#a0826b", fill: "none", strokeWidth: 1 },
          highlighted: { stroke: "#f9e9e3", fill: "none", strokeWidth: 2 },
        },
        area: {
          //normal: { fill: this.props.colorArray[0], stroke: "none", opacity: 0.5 },
          //highlighted: { fill: this.props.colorArray[1], stroke: "none", opacity: 0.8 },
          normal: { fill: solarColorArray[0], stroke: "none", opacity: 0.5 },
          highlighted: { fill: solarColorArray[1], stroke: "none", opacity: 0.8 },
        }
      },
      windForecast: {
        line: {
          normal: { stroke: "#9dbfcb", fill: "none", strokeWidth: 1 },
          highlighted: { stroke: "#82cbe5", fill: "none", strokeWidth: 2 },
        },
        area: {
          //normal: { fill: this.props.colorArray[0], stroke: "none", opacity: 0.5 },
          //highlighted: { fill: this.props.colorArray[1], stroke: "none", opacity: 0.8 },
          normal: { fill: windColorArray[0], stroke: "none", opacity: 0.5 },
          highlighted: { fill: windColorArray[1], stroke: "none", opacity: 0.8 },
        }
      },
      windOffshoreForecast: {
        line: {
          normal: { stroke: "#aadadd", fill: "none", strokeWidth: 1 },
          highlighted: { stroke: "#dd0000", fill: "none", strokeWidth: 2 },
        },
        area: {
          normal: { fill: windOffshoreColorArray[0], stroke: "none", opacity: 0.5 },
          highlighted: { fill: windOffshoreColorArray[1], stroke: "none", opacity: 0.8 },
        }
      },
    };

    const series = this.state.timeSeriesChart.series

    const trackerStyle = {
      line: {
        stroke: "#777",
        strokeWidth: "5px",
        cursor: "crosshair",
        pointerEvents: "none"
      }
    };
    let observedCategories
    let forecastCategories
    
    let observedSolarCategory
    let forecastSolarCategory
    let observedWindCategory
    let forecastWindCategory
    let observedWindOffshoreCategory
    let forecastWindOffshoreCategory
    
    switch (this.props.lang) {
      case "de":
        observedSolarCategory = { key: "solar", label: "Solarenergie", symbolType: "dot", style:{color:'#ffffff!important'} }
        forecastSolarCategory = { key: "solarForecast", label: "Solarenergie", symbolType: "dot" }
        observedWindCategory = { key: "wind", label: "Onshore-Windenergie", symbolType: "dot" }
        forecastWindCategory = { key: "windForecast", label: "Onshore-Windenergie", symbolType: "dot" }
        observedWindOffshoreCategory = { key: "windOffshoreForecast", label: "Offshore-Windenergie", symbolType: "dot" }
        forecastWindOffshoreCategory = { key: "windOffshoreForecast", label: "Offshore-Windenergie", symbolType: "dot" }
        break;
      case "en":
        observedSolarCategory = { key: "solar", label: "solar", symbolType: "dot" }
        forecastSolarCategory = { key: "solarForecast", label: "solar", symbolType: "dot" }
        observedWindCategory = { key: "wind", label: "wind onshore", symbolType: "dot" }
        forecastWindCategory = { key: "windForecast", label: "wind onshore", symbolType: "dot" }
        observedWindOffshoreCategory = { key: "windOffshoreForecast", label: "wind offshore", symbolType: "dot" }
        forecastWindOffshoreCategory = { key: "windOffshoreForecast", label: "wind offshore", symbolType: "dot" }
        break;
      case "fr":
      default:
        observedSolarCategory = { key: "solar", label: "solaire", symbolType: "dot" , style:{color:'#ffffff!important'}}
        forecastSolarCategory = { key: "solarForecast", label: "solaire", symbolType: "dot" }
        observedWindCategory = { key: "wind", label: "éoliennes onshore", symbolType: "dot" }
        forecastWindCategory = { key: "windForecast", label: "éolienne onshore", symbolType: "dot" }
        observedWindOffshoreCategory = { key: "windOffshoreForecast", label: "éolienne offshore", symbolType: "dot" }
        forecastWindOffshoreCategory = { key: "windOffshoreForecast", label: "éolienne offshore", symbolType: "dot" }
    }

    let energySource
    if (this.props.currentTech.solar) {
      if (this.props.currentTech.wind) {
        if (this.props.currentTech.windOffshore) {
          energySource = (this.props.lang === 'de' ? 'Solar-,Onshore- und Offshore-Wind' : (this.props.lang === 'en' ? 'solar and onshore and offshore wind' : 'solaire et éolienne (onshore et offshore)'))
          observedCategories = [
            observedSolarCategory,
            //{ key: "windOnshore", label: "door onshore windturbines", symbolType: "dot" },
            observedWindCategory,
            observedWindOffshoreCategory,

          ]
          forecastCategories = [
            forecastSolarCategory,
            //{ key: "windOnshoreForecast", label: "door onshore windturbines", symbolType: "dot" },
            forecastWindCategory,
            forecastWindOffshoreCategory,
          ]
        }
        else {
          energySource = (this.props.lang === 'de' ? 'Solar- und Onshore-Wind' : (this.props.lang === 'en' ? 'solar and onshore wind' : 'solaire et éolienne (onshore)'))
          observedCategories = [
            observedSolarCategory,
            observedWindCategory,
          ]
          forecastCategories = [
            forecastSolarCategory,
            forecastWindCategory,
          ]
        }
      }
      else {
        if (this.props.currentTech.windOffshore) {
          energySource = (this.props.lang === 'de' ? 'Solar- und Offshore-Wind' : (this.props.lang === 'en' ? 'solar and offshore wind' : 'solaire et éolienne (offshore)'))
          observedCategories = [
            observedSolarCategory,
            observedWindOffshoreCategory,

          ]
          forecastCategories = [
            forecastSolarCategory,
            forecastWindOffshoreCategory,
          ]
        }
        else {
          energySource = (this.props.lang === 'de' ? 'Solar' : (this.props.lang === 'en' ? 'solar' : 'solaire'))
          observedCategories = [
            observedSolarCategory,
          ]
          forecastCategories = [
            forecastSolarCategory,
          ]
        }
      }
    }
    else {
      if (this.props.currentTech.wind) {
        if (this.props.currentTech.windOffshore) {
          energySource = (this.props.lang === 'de' ? 'Onshore- und Offshore-Wind' : (this.props.lang === 'en' ? 'onshore and offshore wind' : 'éolienne (onshore et offshore)'))
          observedCategories = [
            observedWindCategory,
            observedWindOffshoreCategory,
          ]
          forecastCategories = [
            forecastWindCategory,
            forecastWindOffshoreCategory,
          ]
        }
        else {
          energySource = (this.props.lang === 'de' ? 'Onshore-Wind' : (this.props.lang === 'en' ? 'onshore wind' : 'éolienne (onshore)'))
          observedCategories = [
            observedWindCategory,
          ]
          forecastCategories = [
            forecastWindCategory,
          ]
        }
      }
      else {
        energySource = (this.props.lang === 'de' ? 'Offshore-Wind' : (this.props.lang === 'en' ? 'offshore wind' : 'éolienne (offshore)'))
        observedCategories = [
          observedWindOffshoreCategory,
        ]
        forecastCategories = [
          forecastWindOffshoreCategory,
        ]
      }
    }

    //let observedTitle = <p>Waargenomen elektriciteitsproductie (per {(this.props.currentMode === 'realtime' ? 'uur' : 'maand')}) </p>

    let productionBy
    let perHour
    let perMonth
    let inLabel
    let title
    let forecastTitle
    let observedTitle
    let observedForecastTitle
    switch (this.props.lang) {
      case "de":
        //categoryLabel = "door zonnepanelen"
        productionBy = "Produktion by "
        perHour = " pro Stunde"
        perMonth = " pro Monad"
        inLabel = ", in"
        title = energySource + 'energieerzeugung'
        observedTitle = "beobachtete Produktion"
        forecastTitle = "prognostizierte Produktion"
        observedForecastTitle = "beobdachtete und prognostizierte Produktion"
        break
      case "en":
        //categoryLabel = "by solar panels"
        productionBy = "Production by "
        perHour = " per hour"
        perMonth = " per month"
        inLabel = ", in"
        title = 'Production from ' + energySource + ' energy'
        observedTitle = "Observed production"
        forecastTitle = "Expected and production"
        observedForecastTitle = "Observed and expected production"
        break;
      default:
      case "fr":
        //categoryLabel = "de panneaux solaires"
        productionBy = "Production par "
        perHour = " par heure"
        perMonth = " par mois"
        inLabel = ", en"
        title = 'Production d\'énergie ' + energySource
        observedTitle = "Production observée"
        forecastTitle = "Production attendue"
        observedForecastTitle = "Production observée et attendue"
    }

    let observedLegend = (
      <Legend
        type="line"
        align="left"
        stack={true}
        style={legendStyle}
        labelStyle={legendLabelStyle}
        categories={observedCategories}
        className={classes.timeplotLegend}
      />
    );
    //let forecastTitle = <p>Verwachte elektriciteitsproductie (per {(this.props.currentMode === 'realtime' ? 'uur' : 'maand')})</p>
    let forecastLegend = (
      <Legend
        type="line"
        align="left"
        stack={true}
        style={legendStyle}
        labelStyle={legendLabelStyle}
        categories={forecastCategories}
        className={classes.timeplotLegend}
      />
    );
    let tooltip = (
      <ReactTooltip id='timeplot_tooltip' type='light' className={classes.toolTip}>
        {!this.state.hasForecast || this.state.hasMixedForecast ? observedTitle : ''}
        {!this.state.hasForecast || this.state.hasMixedForecast ? observedLegend : ''}
        {this.state.hasForecast ? forecastTitle : ''}
        {this.state.hasForecast ? forecastLegend : ''}
      </ReactTooltip>
    )
    let legend = (this.state.hasMixedForecast ? (
      <Grid container spacing={5}>
        <Grid item xs={6}>
          {observedTitle}
          <Grid container style={{ justifyContent: 'center', }}>
            {observedLegend}
          </Grid>

        </Grid>
        <Grid item xs={6}>
          {forecastTitle}
          <Grid container style={{ justifyContent: 'center', }}>
            {forecastLegend}
          </Grid>
        </Grid>
      </Grid>)
      :
      (
        this.state.hasForecast ? (
          < Grid item xs={12} >
            {forecastTitle}
            <Grid container style={{ justifyContent: 'center', }}>
              {forecastLegend}
            </Grid>

          </Grid >
        ) : (
            <Grid item xs={12}>
              {observedTitle}
              <Grid container style={{ justifyContent: 'center', }}>
                {observedLegend}
              </Grid>

            </Grid>
          )
      )
    );

    let commentTech
    switch (this.props.lang) {
      case "de":
        commentTech = (this.state.currentTech.solar ?
          (this.state.currentTech.windOnshore ?
            (this.state.currentTech.windOffshore ?
              "solar panels and onshore and offshore wind turbines"
              : "solar panels and onshore wind turbines"
            )
            : (this.state.currentTech.windOffshore ?
              "solar panels and offshore wind turbines"
              : "solar panels"
            )
          )
          : (this.state.currentTech.windOnshore ?
            (this.state.currentTech.windOffshore ?
              "onshore and offshore wind turbines"
              : "onshore wind turbines"
            )
            : "offshore wind turbines"
          )
        );
        break
      case "en":
        commentTech = (this.state.currentTech.solar ?
          (this.state.currentTech.windOnshore ?
            (this.state.currentTech.windOffshore ?
              "solar panels and onshore and offshore wind turbines"
              : "solar panels and onshore wind turbines"
            )
            : (this.state.currentTech.windOffshore ?
              "solar panels and offshore wind turbines"
              : "solar panels"
            )
          )
          : (this.state.currentTech.windOnshore ?
            (this.state.currentTech.windOffshore ?
              "onshore and offshore wind turbines"
              : "onshore wind turbines"
            )
            : "offshore wind turbines"
          )
        );
        break;
      case "fr":
      default:
        commentTech = (this.state.currentTech.solar ?
          (this.state.currentTech.windOnshore ?
            (this.state.currentTech.windOffshore ?
              "panneaux solaires et turbines éoliennes onshore et offshore"
              : "panneaux solaires et turbines éoliennes onshore"
            )
            : (this.state.currentTech.windOffshore ?
              "panneaux solaires et turbines éoliennes offshore"
              : "panneaux solaires"
            )
          )
          : (this.state.currentTech.windOnshore ?
            (this.state.currentTech.windOffshore ?
              "turbines éoliennes onshore et offshore"
              : "turbines éoliennes onshore"
            )
            : "turbines éoliennes offshore"
          )
        );
    }

    let currentPlotValue = 0
    let previousValue = 0
    const currentDateTime = this.props.currentDateTime
    this.state.plotData.map(data => {
      let currentValuePerPlot = data.values.filter(obj => obj.datetime.getTime() === currentDateTime.getTime())[0]
      if (currentValuePerPlot != null) {
        // 20181208 there is an overlap to make the curves meet between realtime and forecast, at this point the values do not need to be summed
        if (previousValue !== currentValuePerPlot.value) {
          currentPlotValue += currentValuePerPlot.value
        }
        previousValue = currentValuePerPlot.value
      }
      return true
    });
    if (currentPlotValue < 0.01)
      currentPlotValue = currentPlotValue.toFixed(4)
    else {
      if (currentPlotValue < 5) {
        currentPlotValue = currentPlotValue.toFixed(2)
      }
      else {
        if (currentPlotValue < 50) {
          currentPlotValue = currentPlotValue.toFixed(1)
        }
        else {
          currentPlotValue = currentPlotValue.toFixed(0)
        }
      }
    }

    let inhabitant
    let hourIndicator
    let perMonthAccordingToMode = (this.props.currentMode === 'realtime' ? '' : perMonth)
    switch (this.props.lang) {
      case "de":
        inhabitant = "Einwohner"
        hourIndicator = ":00"
        break;
      case "en":
        inhabitant = "inhabitant"
        hourIndicator = "h"
        break;
      case "fr":
      default:
        inhabitant = "habitant"
        hourIndicator = "h"

    }

    const yAxisLabel = this.props.currentMode === 'realtime' ?
      (this.props.currentFilter === 'energy' ? "GW" : (this.props.currentFilter === 'inhabitants' ? ("W/" + inhabitant) : "MW/km²")) :
      null
    const energyUnit =  this.props.currentMode === 'realtime' ?
    (this.props.currentFilter === 'energy' ? "GWh" : (this.props.currentFilter === 'inhabitants' ? ("Wh/" + inhabitant) : "MWh/km²")) :
    null

    //let productionNature = (this.state.hasForecast ? (this.state.hasMixedForecast ? observedForecastTitle : forecastTitle) : observedTitle)
    let productionNature = title
    let timeplotComment
    switch (this.props.lang) {

      case "de":
        if (this.state.currentTech.solar) {
          if (this.state.currentTech.wind) {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " of solar energy and onshore and offshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
            else {
              timeplotComment = productionNature + " of solar energy and onshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }

          }
          else {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " of solar energy and offshore wind energy" + perMonthAccordingToMode + ", in " + energyUnit
            }
            else {
              timeplotComment = productionNature + " of solar energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
          }
        }
        else {
          if (this.state.currentTech.windOffshore) {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " of onshore and offshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
            else {
              timeplotComment = productionNature + "  of onshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
          }
          else {
            timeplotComment = productionNature + "  of offshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
          }
        }
        break
      case "en":
        if (this.state.currentTech.solar) {
          if (this.state.currentTech.wind) {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " of solar energy and onshore and offshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
            else {
              timeplotComment = productionNature + " of solar energy and onshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }

          }
          else {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " of solar energy and offshore wind energy" + perMonthAccordingToMode + ", in " + energyUnit
            }
            else {
              timeplotComment = productionNature + " of solar energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
          }
        }
        else {
          if (this.state.currentTech.windOffshore) {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " of onshore and offshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
            else {
              timeplotComment = productionNature + "  of onshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
            }
          }
          else {
            timeplotComment = productionNature + "  of offshore wind energy " + perMonthAccordingToMode + ", in " + energyUnit
          }
        }
        break
      case "fr":
      default:
        if (this.state.currentTech.solar) {
          if (this.state.currentTech.wind) {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " d'énergie solaire et éolienne onshore et offshore" + perMonthAccordingToMode + ", en " + energyUnit
            }
            else {
              timeplotComment = productionNature + " d'énergie solaire et éolienne onshore" + perMonthAccordingToMode + ", en " + energyUnit
            }
          }
          else {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " d'énergie solaire et éolienne offshore" + perMonthAccordingToMode + ", en " + energyUnit
            }
            else {
              timeplotComment = productionNature + " d'énergie solaire et" + perMonthAccordingToMode + ", en " + energyUnit
            }
          }
        }
        else {
          if (this.state.currentTech.windOffshore) {
            if (this.state.currentTech.windOffshore) {
              timeplotComment = productionNature + " d'énergie éolienne onshore et offshore " + perMonthAccordingToMode + ", en " + energyUnit
            }
            else {
              timeplotComment = productionNature + " d'énergie éolienne onshore " + perMonthAccordingToMode + ", en " + energyUnit
            }
          }
          else {
            timeplotComment = productionNature + " d'énergie éolienne offshore " + perMonthAccordingToMode + ", en " + energyUnit
          }
        }
    }

    let chartRowHeight = 280
    /*
    if (this.props.windowWidth < 1920) {
      chartRowHeight = 160
    }
    if (this.props.windowWidth < 1660) {
      chartRowHeight = 150
    }
    if (this.props.windowWidth < 1536) {
      chartRowHeight = 150
    }
    if (this.props.windowWidth < 1440) {
      chartRowHeight = 150
    }
    if (this.props.windowWidth < 1366) {
      chartRowHeight = 150
    }
    if (this.props.windowWidth < 1280) {
      chartRowHeight = 140
    }
    
    if (this.props.windowWidth < 960) {
      chartRowHeight = 250
    }
    if (this.props.windowWidth < 768) {
      chartRowHeight = 190
    }
    if (this.props.windowWidth < 600) {
      chartRowHeight = 175
    }
    */
    return (
      <div className={classes.container}>
        {
          /*
          <div className={classes.relativeContainer}>
            <div className={classes.absoluteContainer}>
              <PlotIndicator
                value={currentPlotValue}
                currentFilter={this.props.currentFilter}
                currentMode={this.props.currentMode}
              />
            </div>
          </div>
          */
        }
        <div className={classes.topLegend}>{productionNature}</div>
        <div className={classes.chartDiv}>
          { /* <p className='topLegend'>{timeplotComment}</p> */}

          <Resizable className={classes.chart} 
            style={{
              margin: '2px',
              //backgroundColor:'#fff',
              /*height: '350px', margin: 0*/
            }}>
            <ChartContainer
              //width={this.props.plotWidth}
              timeRange={series.range()}
              format={this.state.currentMode === 'realtime' ? (d3.timeFormat('%H') + (this.props.lang === "de"?":00":'h')) : d3.timeFormat('%b')}
              showGrid={false}
              showGridPosition="under"
              // 20190408 updated to set the correct number of ticks
              timeAxisTickCount={this.state.currentMode === 'realtime' ? 5 : (this.state.plotData[0].values.length + 1)}
              timeAxisStyle={{
                label: {},
                values: {
                  "font-size": '11pt',
                  "font-family": 'Nunito Sans Regular',
                  //color: '#105269',
                  color: '#000000',
                  //fill: '#105269',
                  fill: '#000000',
                },
                ticks: {},
                axis: {}
              }}
              trackerPosition={this.state.currentDateTime}
              trackerStyle={trackerStyle}
            //width={300}
            //minTime={this.state.data[0].values[0].datetime}
            >
              <ChartRow
                height={chartRowHeight}
              >
                <YAxis
                  id="value"
                  label={yAxisLabel}
                  labelOffset={yLabelOffset}
                  min={0}
                  max={max}
                  width={60}
                  type="linear"
                  style={{
                    label: {
                      "font-weight": 700,
                      "font-size": '11pt',
                      "font-family": 'Nunito Sans Regular',
                    },
                    values: {
                      "font-size": '11pt',
                      "font-family": 'Nunito Sans Regular',
                      //color: '#105269',
                      color: '#000000',
                      //fill: '#105269',
                      fill: '#000000',
                    },
                    ticks: {},
                    axis: {}
                  }}
                  format={yAxisFormat}
                  tickCount={3}
                />

                <Charts>
                  <AreaChart
                    axis="value"
                    style={plotStyle}
                    series={series}
                    breakArea={false}
                    columns={cols}
                    stack={false}
                    fillOpacity={0.2}
                    opacity={0.2}
                    interpolation={interpolationType}
                    highlight={this.state.timeSeriesChart.highlight}
                  //onHighlightChange={highlight =>
                  //  this.setState((previousState, props) => {
                  //    return {
                  //      timeSeriesChart: {
                  //        ...previousState.timeSeriesChart,
                  //        highlight: highlight,
                  //      }
                  //    }
                  //  })
                  //}
                  >
                  </AreaChart>
                </Charts>
              </ChartRow>

            </ChartContainer>
          </Resizable>
          <Grid container className={classes.indicatorTooltipContainer}>
            <Grid item xs={2}></Grid>
            <Grid item xs={8} md={7} lg={8}>
              <PlotIndicator
                value={currentPlotValue}
                currentFilter={this.props.currentFilter}
                currentMode={this.props.currentMode}
                lang={this.props.lang}
              />
            </Grid>
            <Grid item xs={2} md={3} lg={2}>
              {tooltip}
              <div
                className={classes.legendBox}
                data-for='timeplot_tooltip'
                data-tip='timeplot_tooltip'
              >
                {this.props.lang==='de'?'Legende':(this.props.lang==='en'?'Legend':'Légende')}
            </div>
            </Grid>
          </Grid>

          {
            /*
            <div>{legend}</div>
            */
          }

        </div>
      </div>
    )
  }
}

TimePlot.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TimePlot)